module.exports = {
  language: {
    name: '中文',
    current: '当前语言',
  },
  common: {
    save: '保存',
    sure: '确 定',
    tip: '提示',
    submit: '提交',
    option: '操作',
    edit: '编辑',
    cancel: '删除',
    send: '发 送',
    viewMore: '查看更多',
    rules: {
      phone: '手机号码不能为空',
      newPassword: '新密码不能为空',
      confirmPassword: '确认新密码不能为空',
      email: '邮箱不能为空',
    },
    require: '请填写必填项!',
    phone: '手机：',
    email: '邮箱：',
    collected: {
      exhibition: '收藏展商',
      exhibits: '收藏展品',
      live: '收藏直播',
      activity: '收藏活动',
    },
    recommend: {
      exhibition: '推荐展商',
      exhibits: '推荐产品',
      live: '推荐直播',
      activity: '推荐活动',
    },
    tips: {
      exhibition: '推荐展商 暂无产品信息',
      exhibits: '暂无产品信息',
      live: '暂无直播信息',
      activity: '暂无活动信息',
      message: '暂无信息数据',
    },
    viewAll: '查看全部',
    myMessage: '我的消息',
    consult: '咨询展商',
    meetingRoom: '会议室',
    qrCode: '手机扫描二维码观看直播',
    changeContent: '换一批',
    search: '搜索',
    boothNum: '展位号：',
    more: '了解更多',
    collect: '收藏',
    clearCollect: '取消收藏',
    view: '查看',
  },
  login: {
    title: '北京中国国际展览中心（新馆） | 2023年10月25-28日',
    goback: '返回首页',
    en: 'EN',
    zh: 'CH',
    welcome: '欢迎登录',
    content: '中国国际采矿展线上展会观众个人中心',
    placeholder1: '请输入手机号',
    placeholder2: '请输入密码',
    agree: '我已经阅读并同意',
    privacyStatement: '"隐私保护声明"',
    forgetPassword: '忘记密码？',
    loginNow: '立即登录',
    clickTip: '没有账号?点击',
    register: '“参观注册”',
    registerInfo: '，进行观众预登记，完成注册',
    visitRegistration: '参观注册',
    validatorInfo: '两次输入的密码不一致，请重新输入',
    reset: {
      title: '重置密码',
      label1: '注册手机号：',
      placeholder1: '请输入手机号码',
      label2: '验证码：',
      placeholder2: '请输入验证码',
      sendCode: '发送验证码',
      label3: '新密码：',
      placeholder3: '请输入新密码',
      label4: '确认新密码：',
      placeholder4: '请确认新密码',
    },
    rules: {
      code: '验证码不能为空',
      password: '密码不能为空',
    },
    messages: {
      code: '验证码已发送，请注意查收!',
      success: '密码重置成功！',
      fail: '密码重置失败！',
      loginError1: '登录失败,请勾选条款!',
      loginError2: '登录失败,账号或密码错误!',
      loginSuccess: '恭喜你,登陆成功!',
    },
  },
  home: {
    editInfo: '编辑信息',
    company: '公司：',
    address: '地址：',
    statistics: '数据统计',
  },
  //团体时间
  teamInvite: {
    teamTitle: '团体邀请',
    tishi1: '为切实保障参观观众和参展企业的健康安全工作，提供安全、有序的参展环境，主办方将严格落实《国务院联防联控机制要求》和《北京会展行业新冠肺炎防控指',
    tishi2: '南》的相关规定，对于全体参展/参观人员采用展前“预约参观+实名认证”流程，及现场刷“实体身份证原件”的形式入场。',
    placeholder1: '请输入姓名/公司名',
    search: '搜索',
    addbuys: '新增买家',
    departement: '部门/职责',
    companyName: '公司',
    companyAddress: '公司地址',
    editbuy: '编辑买家信息',
    inforTishi: '信息提交失败',
    inforTishi2: '信息提交失败,请稍候重试',
    inforTishi3: '信息提交成功',
    inforTishi4: '信息已提交成功；',
    idcart: '身份证',
    certificate: '军官证',
    passport: '护照',
    hk: '港澳通行证',
  },
  person: {
    title: {
      info1: '个人信息',
      info2: '带',
      info3: '*',
      info4: '为必填项',
    },
    tabs: {
      tab1: '基本信息',
      tab2: '确认函',
      tab3: '调查问卷',
      tab4: '团体注册',
      tab5: '修改密码',
    },
    baseInfos: {
      companyName: '单位名称：',
      address: '单位地址：',
      name: '姓名：',
      named: '称呼：',
      named1: '先生',
      named2: '女士',
      type: '证件类型：',
      number: '证件号码：',
      phone: '手机号：',
      email: 'E-mail：',
      dept: '部门：',
      duty: '职务：',
      tips: {
        emailTip: '用于接收预登记确认函，建议使用个人工作邮箱，避免使用公司公共邮箱',
      },
      rules: {
        number: '身份证号不能为空',
      },
    },
    letter: {
      company: '公司：',
      phone: '手机号：',
      registAccount: '用户名：',
      password: '密码：',
      time: '参观时间：',
      address: '展会地点：',
      position: '观众入口：',
      img: '展位图：',
      companyName: '中国煤炭工业国际技术咨询有限责任公司',
      telephone: '电话：',
      contacts: '联系人：',
      tips: {
        tip1: '*',
        tip2: '请注意',
        tip3: '您的电子确认函已经发送至您的邮箱，如未收到邮件，请检查您的垃圾邮件',
        tip4: '如需修改注册信息，请单击此处登录中国国际采矿展观众中心后台。',
      },
      infos: {
        info1: '您的参观注册信息',
        info2: '您的登录账户信息',
        info3: '参观信息',
        info4: '参观咨询',
      },
      informations: {
        title: '尊敬的',
        tip1: '感谢您注册参观第二十届中国国际煤炭采矿技术交流及设备展览会（China Coal & Mining Expo 2023）.',
        tip2: '您已成功完成参观预登记。本届展会将于2023年10月25-28日在北京中国国际展览中心（新馆）举行，期待您的光临！',
        tip3: '请您保存此确认函，展会现场请您携带本人身份证原件入场参观。',
        time1: '10月25-28日，9:00-17:00',
        time2: '',
        address: '北京中国国际展览中心（新馆）',
        position: '新国展东、南、西、北登录厅',
        linkPerson: '王子辰',
        phone: '010-84293614',
        email: 'chinaminexpo@vip.163.com',
      },
    },
    quest: {
      other: '其他（请注明）',
      placeholder: '请输入内容',
    },
    group: {
      button1: '新增参展人员',
      button2: '编辑成员',
      button3: '添加成员',
      tip1: '如果人员较多，可以按模板提交人员列表，',
      downloadText: '点击下载模板',
      uploadText: '上传文件',
      tip2: '请勾选要提交人员信息再进行提交',
      downloadFileName: '团队注册模板.xlsx',
      noSubmit: '未提交',
      submited: '已提交',
      tableLabel: {
        name: '姓名',
        type: '证件类型',
        number: '证件号码',
        unitName: '单位名称',
        unitAddress: '单位地址',
        duty: '职务',
        phone: '手机',
        email: 'E-mail',
        status: '状态',
        phoneNumber: '手机号码：',
      },
      placeholders: {
        name: '请输入姓名',
        unitName: '请输入单位名称',
        unitAddress: '请输入单位地址',
        type: '请输入证件类型',
        number: '请输入证件号码',
        phoneNumber: '请输入手机',
        email: '请输入E-mail',
        duty: '请输入职务',
      },
      rules: {
        require: {
          name: '姓名不能为空',
          unitName: '单位名称不能为空',
          type: '证件类型不能为空',
          number: '证件号码不能为空',
        },
        errors: {
          type: '请先选择证件类型',
          type1: '身份证号码不合规，请重新输入',
          phone: '手机号码格式不合规，请重新输入',
          email: '邮箱格式不合规，请重新输入',
          authFail: '身份证号验证失败,请重新输入身份证号!',
        },
      },
      options: {
        label1: '身份证',
        label2: '军官证',
        label3: '护照',
        label4: '港澳通行证',
      },
      messages: {
        excel: '上传成员excel表成功!',
        submit: '提交参展人员信息成功!',
        edit: '修改成员成功!',
        cancelSuccess: '删除成员成功!',
        addSuccess: '新增成员成功!',
        addFail: '新增成员失败!',
        limit: {
          tip1: '当前限制选择 3 个文件，本次选择了',
          tip2: '个文件，共选择了',
          tip3: '个文件',
        },
        confirm: {
          tip1: '确定移除',
          tip2: '？',
        },
        cancel: {
          text: '确认要删除吗？',
          title: '注意!',
          confirmText: '确定',
          cancelText: '取消',
        },
      },
    },
    password: {
      passwordRule: '输入的密码至少6位，请重新输入',
      confirmRule: '两次输入的密码不一致，请重新输入',
    },
  },
  recommend: {
    exhibition: '推荐展商',
    exhibits: '推荐展品',
    live: '推荐直播',
    activity: '推荐活动',
  },
  sidebar: {
    projectName: '观众中心',
    home: '首页',
    baseInfo: '个人信息',
    recommend: '为我推荐',
    collected: '我的收藏',
    message: '我的消息',
    error: '注销失败',
    xianshang: '线上展会',
  },
  search: {
    placeholderType: '请选择产品类型',
    placeholderName: '请输入展商名称',
    placeholderProName: '请输入展品名称',
    nodata: '暂无推荐',
    nocCollect:"暂无收藏"
  },
  collected: {
    exhibition: '收藏展商',
    exhibits: '收藏展品',
    live: '收藏直播',
    activity: '收藏活动',
    consult: '在线洽谈',
  },
  messages: {
    info: '展商信息',
    company: '发件公司',
    time: '发件时间',
  },
  tinymce: {
    placeholder: '请输入',
  },
  header: {
    title: '中国国际煤炭采矿技术交流及设备展览会',
    time: '北京中国国际展览中心（新馆） 2023年10月25-28日',
  },
  logout: {
    cancellation: '注销',
    tip: '提示',
    sureTip: '你确定退出登录？',
    sure: '确 定',
    cancel: '取 消',
  },
  privacy: {
    title: '隐私保护声明',
    statement:
      '本网站承诺保护您的个人隐私。您无需提供任何个人信息就可以访问我们站点的大多数网页。不过,有时候,我们的确需要某些信息才能为您提供您请求的服务,本隐私权声明解释了这些情况下的数据收集和使用情况。本隐私权声明仅适用于本网站。',
    tip1: {
      title: '收集您的个人信息',
      info1:
        '我们可能需要能识别您身份的信息(用户个人信息)或者可以与您联系的信息。通常，在您购买或注册本网站产品时，我们会请求您提供这些信息。本网站收集的个人信息通常仅限于用户名称、联系电话、联系地址、QQ号等基本信息，不过，在提供您请求的服务时,也可能需要收集其他信息。',
      info2:
        '本网站也会收集有关您的电脑软件和硬件的某些信息。这些信息可能包括:您的IP地址、浏览器类型、操作系统、域名、访问时间以及相关的网络站点地址。这些信息用于服务的运行、保证服务质量以及提供有关使用本网站的一般统计数据。',
      info3: '本网站也会收集客户在本网站中访问了哪些页面的信息。这些站点访问数据仅通过唯一的ID号标识,除非用户同意,这些数据决不会与个人信息相链接,详见下文。',
    },
    tip2: {
      title: '使用您的个人信息',
      info1: '您的个人信息主要有以下几个用途:',
      info2: '1、确保我们的网站满足您的要求。',
      info3: '2、传送您请求或购买的服务,比如产品。',
      info4: '3、帮助我们创建和提供更贴近您的内容。',
      info5: '4、提醒您从本网站获得产品升级信息、特价产品、更新信息和其他新服务(如果您请求了这些服务)。',
      info6: '5、允许您访问我们网站上有一定限制的区域。',
      info7: '6、同意本协议，即视为允许我们向您的通讯工具上发送与本公司产品相关的促销信息。',
      info8:
        '为了便于研究,我们将会合并站点访问数据和匿名统计信息,然后我们可能利用这些累计的信息提供更贴近您的内容。在本网站的某些访问受限制的部分,如果您同意,我们将会合并您的个人信息和站点访问数据,以便为您提供个性化内容。如果您拒绝我们这么做,我们不会为您提供个性化服务,也不会合并您的个人信息和站点访问数据。',
      info9:
        '我们偶尔会雇用其他公司代表我们提供受限服务,包括打包、邮寄和发送购买的物品,回答顾客对产品或服务的提问,邮递信件以及处理会议注册等。我们只向那些公司提供这些服务所需的信息,并禁止将这些信息用于其他目的。',
      info10:
        '本网站会在法律要求的情况下透露您的个人信息,或者有充分理由相信必须这样做才能:(a)满足法律的明文规定,或者符合本网站或本站点适用的法律程序;(b)保护本网站及其系列网络站点的权利或财产,以及(c)在紧急情况下保护本网站员工、本网站产品或服务的用户或大众的个人安全。',
    },
    tip3: {
      title: '控制您的个人信息',
      info1: '当您通过注册或其他方式向我们提供个人信息时,本网站不会未经允许将这些信息与第三方共享,前面已经列出的情况除外。这些信息仅用于前面已经提到的用途。',
      info2:
        '本网站可能会定期发送短信或拨打电话,通报与您请求的产品或服务有关的技术服务或安全问题,或者确认您请求的产品或服务。您无法选择撤消这些服务,因为它们是您所选服务的基本组成部分。',
    },
    tip4: {
      title: '您的个人信息的安全',
      info1:
        '本网站严格保护您的个人信息的安全。我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄漏。例如,我们在位于受控场所的计算机服务器上存储您提供的个人信息,而且对这些服务器的访问是受到限制的。当在Internet上传送敏感信息(例如信用卡号)时,我们通过使用加密(例如安全套接字层(SSL)协议)来保护信息。',
    },
    tip5: {
      title: 'Cookie的用途',
      info1:
        '某人访问站点时,他的计算机上就会留下一个Cookie(如果客户同意接受Cookie),如果客户以前访问过这个站点,站点会读取该Cookie。Cookie的用途之一是帮助收集上面介绍的站点访问统计数据。',
      info2:
        '我们还使用Cookie来收集有关客户点击的新闻快递链接的信息。这些信息用于确保我们向客户发送的信息正是客户想阅读的。我们以累计的形式收集这些信息,它决不会与您的个人信息相链接。',
      info3:
        '可能会在我们的站点上使用Webbeacon(也叫做清晰的gif图形技术)或者活动标记来帮助投放Cookie。这项技术让我们知道有多少访问者点击了本网站网络页上的关键元素(比如链接或图形)。我们在本网站上不用这种技术获取您的个人可识别信息;这只是用来统计本网站网络站点累计使用情况的一个工具。我们可能和合作伙伴公司共享站点累计统计信息,但我们不允许其他公司将清晰的gif图形放到我们的站点上。',

      info4: '如果您选择不让浏览器接收本网站网络站点上的Cookie,您可以浏览屏幕上的文字,但不能体验个性化的浏览访问,也不能订阅站点上提供的服务。',
    },
    tip6: {
      title: '联系信息',
      info1: '本网站欢迎您就本隐私权声明发表意见,请用电子邮件与我们联系。',
    },
    tip7: {
      title: '关于网站',
      info1:
        '1、本网站中的文章(包括转贴文章)的版权仅归原作者所有,若作者有版权声明的或文章从其它网站转载而附带有原所有站的版权声明者,其版权归属以附带声明为准。',
      info2: '2、由于与本网站链接的其它网站所造成之个人资料泄露及由此而导致的任何法律争议和后果,本网站均得免责。',
      info3:
        '3、当政府司法机关依照法定程序要求本网站披露个人资料时,我们将根据执法单位之要求或为公共安全之目的提供个人资料。在此情况下之任何披露,本网站均得免责。',
    },
    tip8: {
      title: '关于网站运行',
      info1:
        '1、本网站如因系统维护或升级而需暂停服务时,将事先公告。若因线路及非本公司控制范围外的硬件故障或其它不可抗力而导致暂停服务,于暂停服务期间造成的一切不便与损失,本网站不负任何责任。',
      info2:
        '2、任何由于计算机2000年问题、黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营的不可抗力而造成的个人资料泄露、丢失、被盗用或被窜改等,本网站均得免责。',
    },
    tip9: {
      title: '关于法律责任',
      info1: '1、本网站使用者因为违反本声明的规定而触犯中华人民共和国法律的,一切后果自己负责,本网站不承担任何责任。',
      info2: '2、凡以任何方式登陆本网站或直接、间接使用本网站资料者,视为自愿接受本网站声明的约束。',
      info3: '3、本声明未涉及的问题参见国家有关法律法规,当本声明与国家法律法规冲突时,以国家法律法规为准。',
    },
    tip10: {
      title: '关于解释权',
      info1: '本网站之声明以及其修改权、更新权及最终解释权均属本网站所有。',
    },
  },
  //尾部
  footer: {
    title: '中国国际煤炭采矿技术交流及设备展览会组委会',
    titleTop: '第二十届',
    titleBottom: '中国国际煤炭采矿技术交流及设备展览会组委会',
    link: '快速链接',
    company: '汇显展览有限公司',
    weChatOfficialAccount: '展览会微信公众号',
    qrCodeAttention: '请扫描二维码进行关注',
    mobileQrCodeAttention: '请扫描二维码关注展览会微信公众号',
    copyright: '版权所有：中国煤炭工业国际技术咨询有限责任公司',
    technicalSupport: '技术支持：中煤信息技术(北京)有限公司',
    spareNumber1: '京公网安备11010102002548号',
    spareNumber2: '京ICP备09033595号-1',
    address: '北京市东城区安外大街乙88号中煤大厦',
    linkUrl: {
      viewcz: '我要参展',
      viewcg: '我要参观',
      zwt: '展位图',
      zhrc: '展会日程',
      hzZhanhui: '展会官网',
      mjlt: '煤机论坛',
    },
    unit: {
      title1: '主办单位',
      title2: '协办单位',
      title3: '承办单位',
      text1: '中国煤炭工业协会',
      text2: '中国中煤能源集团有限公司',
      text3: '中国煤炭工业国际技术咨询有限责任公司',
    },
  },
  //菜单栏
  navbar: {
    home: '首页',
    PersonalInfo: '个人信息',
    basicInfo: '基本信息',
    letter: '确认函',
    questionnaire: '调查问卷',
    updataPassword: '修改密码',
    publicize: '线上展会',
    collecytion: '我的收藏',
    collExhibitors: '收藏展商',
    collProduct: '收藏展品',
    collLive: '收藏直播',
    collActive: '收藏活动',
    MyMessage: '我的消息',
    logout: '注销',
  },
   mobile:{
       editRegisMessage:'如需修改注册信息,请',
       clickHereL:'单击此处',
       logBackManage:'登录中国国际采矿展观众中心后台。',
       clickLook:'点击查看',
       authentication:'实名认证通过!',
       talk:'咨询展商',
       Favorites:'收藏展商',
       cancel:"取消收藏",
       sendImg:'发送图片',
       input:'请输入',
       send:'发送',
       FavoritesPro:'收藏展品',
   },
   Favorites:{
    collentExhibitors:'收藏展商',  //收藏展商
    collentExhibits:'收藏展品', //收藏展品
    collentLive:'收藏直播',
    collentActive:'收藏活动',
   }



};




